// modules
import React, { useRef, useState, useEffect } from "react";
import AudioPlayer, { RHAP_UI } from "react-h5-audio-player";
// styles
import "react-h5-audio-player/lib/styles.css";

const CustomAudioPlayer = ({ url }) => {
    const baseUrl = 'https://ekitap.kz';
    const audioRef = useRef(null);
    const dropdownRef = useRef(null); // ref для блока с кнопкой и меню
    const [speed, setSpeed] = useState(1);
    const [open, setOpen] = useState(false);

    const speeds = [0.5, 0.75, 1, 1.25, 1.5, 2];

    const handleChangeSpeed = (newSpeed) => {
        setSpeed(newSpeed);
        setOpen(false);

        if (
            audioRef.current &&
            audioRef.current.audio &&
            audioRef.current.audio.current
        ) {
            audioRef.current.audio.current.playbackRate = newSpeed;
        }
    };

    // обработка клика вне
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setOpen(false);
            }
        };

        if (open) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [open]);

    return (
        <AudioPlayer
            ref={audioRef}
            src={baseUrl + url}
            showJumpControls={false}
            customAdditionalControls={[
                RHAP_UI.LOOP,
                <div
                    key="speed-control"
                    ref={dropdownRef}
                    style={{ position: "relative" }}
                >
                    {/* Кнопка открытия меню */}
                    <button
                        onClick={() => setOpen(!open)}
                        style={{
                            background: "transparent",
                            border: "1px solid #ccc",
                            borderRadius: "2px",
                            padding: "6px",
                            marginLeft: "8px",
                            cursor: "pointer",
                            fontSize: "12px",
                        }}
                    >
                        {speed}x ▾
                    </button>

                    {/* Выпадающее меню */}
                    {open && (
                        <div
                            style={{
                                position: "absolute",
                                bottom: "110%",
                                left: 0,
                                background: "#fff",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                boxShadow: "0 0 3px 0 rgba(0, 0, 0, 0.2)",
                                overflow: "hidden",
                                zIndex: 10,
                            }}
                        >
                            {speeds.map((s) => (
                                <div
                                    key={s}
                                    onClick={() => handleChangeSpeed(s)}
                                    style={{
                                        padding: "4px 8px",
                                        fontSize: "12px",
                                        cursor: "pointer",
                                        background: s === speed ? "#eee" : "#fff",
                                    }}
                                >
                                    {s}x
                                </div>
                            ))}
                        </div>
                    )}
                </div>,
            ]}
        />
    );
};

export default CustomAudioPlayer;
